import { render } from "./newkb.vue?vue&type=template&id=a0ac0f54"
import script from "./newkb.vue?vue&type=script&lang=js"
export * from "./newkb.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css"
import "./newkb.vue?vue&type=style&index=1&id=a0ac0f54&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__